<div class="panel panel-default" style="margin-bottom: 50px;">
  <div class="panel-heading">
    <h4>Endereço Residencial</h4>
  </div>
  <div class="panel-body">
    <div *ngIf="processandoCEP" class="text-center">
      <i class="fa fa-spinner fa-pulse fa-4x"></i>
    </div>
    <label *ngIf="!processandoCEP" for="cep">
      CEP
    </label>
    <div *ngIf="!processandoCEP"
          class="input-group col-xs-12 col-md-6 col-md-offset-3 ">
      <input id="cep"
             type="text"
             [ngClass]="{'campoVazio': cartao.enderecoResidencial.uf === ''}"
             [(ngModel)]="cartao.enderecoResidencial.cep"
             name="cep"
             class="form-control" 
             placeholder="Formato: 00000000"
             (keyup)="validaEnter($event)"
             uiCep>
      <span class="input-group-btn">
            <button class="btn app-btn-best"
                    type="button"
                    id="buscarCep"
                    (click)="buscarCEP()">
              <i class="fa fa-search"></i> Localizar
            </button>
      </span>
    </div>
    <div *ngIf="cartao.enderecoResidencial.uf !== '' && cartao.enderecoResidencial.cep !== undefined && cartao.enderecoResidencial.cep.length === 8" class="col-xs-12">
      
      
      <div class="form-group col-md-12 col-lg-12">
        <label for="logradouro">Logradouro</label>
        <input type="text"
               id="logradouro"
               [(ngModel)]="cartao.enderecoResidencial.logradouro"
               class="form-control input-sm"
               [readonly]="logradouroIsReadOnly"
               maxlength="256"
               required>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <label for="lote">Número</label>
        <input type="text"
               id="lote"
               [(ngModel)]="cartao.enderecoResidencial.numero"
               class="form-control input-sm"
               maxlength="64">
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <label for="complemento">Complemento</label>
        <input type="text"
               id="complemento"
               [(ngModel)]="cartao.enderecoResidencial.complemento"
               class="form-control input-sm"
               maxlength="256">
     </div>
      <div class="form-group col-md-4 col-lg-4 {{ !cartao.enderecoResidencial.bairro ? 'has-error' : '' }}">
        <label for="bairro">Bairro</label>
        <input type="text"
               id="bairro"
               [(ngModel)]="cartao.enderecoResidencial.bairro"
               class="form-control input-sm"
               [readonly]="bairroIsReadOnly"
               maxlength="256"
               required>
      </div>
      <div class="form-group col-md-4 col-lg-4 {{ !cartao.enderecoResidencial.cidade ? 'has-error' : '' }}">
        <label for="cidade">Cidade</label>
        <input type="text"
               id="cidade"
               [(ngModel)]="cartao.enderecoResidencial.cidade"
               class="form-control input-sm"
               readonly>
      </div>
      <div class="form-group col-md-4 col-lg-4 {{ !cartao.enderecoResidencial.uf ? 'has-error' : '' }}">
        <label for="uf">UF</label>
        <input type="text"
               id="uf"
               [(ngModel)]="cartao.enderecoResidencial.uf"
               class="form-control input-sm"
               readonly>
      </div>


    </div>
  </div>


</div>


// WEBPACK FOOTER //
// ./src/app/resources/componentes/endereco/endereco.component.html